import ApiService from "../../services/ApiService"
import { isLoading, setError, setSuccessMessage } from "./uxAction"
const getAccessToken = () => localStorage.getItem('accessToken');

export function createCategory({ categoryName, categoryParentId }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokePost(process.env.REACT_APP_API_URL + `/admin/api/secured/categories`, {
            categoryName,
            categoryParentId
        })

        if (resp.status >= 400) {
            dispatch(setError(resp.data.errors))
        }

        dispatch(isLoading(false))

        if (callback)
            callback(resp.data.data)
    }
}

export function updateCategory({ categoryId, categoryName }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokePatch(process.env.REACT_APP_API_URL + `/admin/api/secured/categories/${categoryId}`, {
                categoryName
            })

            dispatch(isLoading(false))

            if (resp.status >= 400)
                dispatch(setError(resp.data.errors))

            if (callback)
                callback()


        } catch (e) { }
    }
}

export function bulkDeleteCategory({ categoryIds = [] }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokeDelete(process.env.REACT_APP_API_URL + `/admin/api/secured/categories`, {
                categoryIds
            })

            dispatch(isLoading(false))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "Item(s) deleted"
                }))
            }

            if (callback)
                callback()

        } catch (e) { }
    }
}

export function fetchAllCategory({ query, page = 0, limit = 3 }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/categories?query=${query}&page=${page}&limit=${limit}`)

        dispatch(isLoading(false))

        if (resp.status === 200) {
            const { data } = resp.data
            await dispatch({
                type: 'FETCH_CATEGORY_TABLE',
                payload: data
            })


            if (callback)
                callback({
                    filteredData: data.filteredData,
                    totalFiltered: data.filteredData?.length,
                    total: data.total
                })
        }


    }
}

export function fetchAllCategoryByParent({ categoryParentId }, callback) {
    return async (dispatch) => {
        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/categories/by-parent/${categoryParentId}`)

        if (resp.status === 200) {
            const { data } = resp.data
            await dispatch({
                type: 'FETCH_CATEGORY_CHILD_TABLE',
                payload: data
            })

            if (callback)
                callback(data)
        }
    }
}

export function fetchAllCategorySeletable() {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/categories/all`)

        dispatch(isLoading(false))

        if (resp.status == 200) {
            const { data } = resp.data

            let selectableFormat = data.filteredData.map(c => ({
                label: c.categoryName,
                value: c._id
            }))

            await dispatch({
                type: 'FETCH_CATEGORY_SELECTABLE',
                payload: selectableFormat
            })

        }
    }
}

export function fetchAll() {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/categories/all`)
        
        dispatch(isLoading(false))

        if (resp.status == 200) {
            const { data } = resp.data

            let selectableFormat = data.filteredData.map(c => ({
                label: c.categoryName,
                value: c._id
            }))

            await dispatch({
                type: 'FETCH_CATEGORY_ALL',
                payload: selectableFormat
            })

        }
    }
}

export function updateCategoryImage({ categoryId, thumbnail }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const formData = new FormData();
            formData.append('thumbnail', thumbnail);
            
            const resp = await fetch(
                process.env.REACT_APP_API_URL + `/admin/api/secured/categories/${categoryId}/image`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${getAccessToken()}`,
                        // "Content-Type" : "multipart/form-data",
                    },
                    body: formData 
                }
            )

            dispatch(isLoading(false))

            if (resp.status >= 400)
                dispatch(setError(resp.data.errors))

            if (callback)
                callback()


        } catch (e) { }
    }
}